/**
 * Application Entry Point
 *
 * i18n is initialized explicitly via initI18n() AFTER all static
 * imports resolve — this prevents TDZ errors where initReactI18next
 * tries to access React before its binding is initialized.
 */

import './styles/globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { registerSW } from 'virtual:pwa-register';

import { ErrorBoundary } from '@/components/common/ErrorBoundary';

import { App } from './App';
import { initI18n } from './i18n/config';

// Initialize i18n now that React is fully loaded
initI18n();

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New version available. Reload to update?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('Prism ready to work offline');
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

